import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../hooks/hooks';
import NexusNodesComponent from '../components/nexus-nodes-component';
import PageLoader from '../../../../components/PageLoader';
import { zone } from '../../../../redux/zone/action';
import { node } from '../../../../redux/node/action';
import { selectNodeQueryItems } from '../../../../redux/node/selector';
import { selectListItems } from '../../../../redux/library/selector';
import { selectZoneListItems } from '../../../../redux/zone/selector';

const ManagementNexusNode = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const queryItems = useSelector(selectNodeQueryItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [selectedNexusNodes, setSelectedNexusNodes] = useState<any>({})
    const libraryData = useSelector(selectListItems)
    const itemsData = useSelector(selectZoneListItems)
    const fetchNexusNodesQueryById = () => {
        dispatch(node.query({
            url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/nexus_management/global_nexus_nodes/fetch-detail`,
            entity: 'NexusNodes',
            jsonData: {
                "Context": {},
                Records: [
                    {
                        "Id": (parmas?.id),
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
        })
    }

    const handleInnerFormChange: any = (event: any, field: string) => {
        setSelectedNexusNodes({ ...selectedNexusNodes, [field]: event });
    }

    useEffect(() => {
        if (parmas?.id > 0) {
            fetchNexusNodesQueryById()
            setIsLoading(false)
        } else {
            setIsLoading(false)
        }
    }, []
    )

    useEffect(() => {
        fetchNexusARecordTypeList()
        if (isQuery) {
            setSelectedNexusNodes(queryItems?.result?.items)
        }
    }, [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        if (parmas?.id > 0) {
            await dispatch(zone.resetAction({ actionType: 'update' }))
            await dispatch(zone.update({
                url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/nexus_management/global_nexus_nodes`,
                entity: 'NexusNodes',
                jsonData: {
                    "Context": {},
                    Records: [
                        {
                            Id: selectedNexusNodes?.GlobalNexusNodeId || 0,
                            Name: selectedNexusNodes?.Name || "",
                            Code: selectedNexusNodes?.Code || "",
                            Description: selectedNexusNodes?.Description || "",
                            Instruction: selectedNexusNodes?.Instruction || "",
                            NexusZoneId: selectedNexusNodes?.NexusZoneId || 0,
                            GlobalNexusZoneId: selectedNexusNodes?.GlobalNexusZoneId || 0,
                            ServicePodId: selectedNexusNodes?.ServicePodId || 0,
                            DBAId: selectedNexusNodes?.DBAId || 0,
                            DBATenantId: selectedNexusNodes?.DBATenantId || 0,
                            NodeTypeId: selectedNexusNodes?.NodeTypeId || 0,
                            Address1: selectedNexusNodes?.Address1 || "",
                            Address2: selectedNexusNodes?.Address2 || "",
                            Citycode: selectedNexusNodes?.Citycode || "",
                            Statecode: selectedNexusNodes?.Statecode || "",
                            Lattitude: selectedNexusNodes?.Lattitude || 0,
                            Longitude: selectedNexusNodes?.Longitude || 0,
                            ContactPersonName: selectedNexusNodes?.ContactPersonName || "",
                            ContactPhoneNumber: selectedNexusNodes?.ContactPhoneNumber || "",
                            DispatchStartTime: selectedNexusNodes?.DispatchStartTime || null,
                            DispatchEndTime: selectedNexusNodes?.DispatchEndTime || null,
                            CutoffTime: selectedNexusNodes?.CutoffTime || null,
                            OperatingHours: selectedNexusNodes?.OperatingHours || null,
                            IsExpressDeliveryCapable: selectedNexusNodes?.IsExpressDeliveryCapable || false,
                            IsReverseDeliveryCapable: selectedNexusNodes?.IsReverseDeliveryCapable || false,
                            EffectiveFromDateUtc: selectedNexusNodes?.EffectiveFromDateUtc || null,
                            EffectiveToDateUtc: selectedNexusNodes?.EffectiveToDateUtc || null
                        }
                    ]
                }
            })).then(() => {
                back()
            })
        } else {
            await dispatch(zone.resetAction({ actionType: 'create' }))
            await dispatch(zone.create({
                url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/nexus_management/global_nexus_nodes`,
                entity: 'NexusNodes',
                jsonData: {
                    Records: [
                        {
                            "Context": {},
                            "Message": selectedNexusNodes
                        }
                    ]
                }
            })).then(() => {
                back()
            })
        }
    }

    const back = () => {
        navigate('/nexus/nexus-management/nexus-node')
    }
    const fetchNexusARecordTypeList = () => {
        dispatch(zone.list({
            url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/nexus_management/global_nexus_zones/fetch`,
            entity: 'NexusZones',
            jsonData: {

                "Context": {
                },
                "Records": [
                    {},
                ],
                "PageNumber": "1",
                "PageSize": "100",
                "SortField": "Id",
                "SortOrder": "desc",

            }
        }))
    }
    return (
        <>
            {isLoading ? <PageLoader /> :
                <NexusNodesComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectedNexusNodes={selectedNexusNodes}
                    back={back}
                    queryItems={queryItems?.result?.items}
                    handleFormSubmit={handleFormSubmit}
                    NexusZoneId={libraryData?.result?.NexusZoneRank}
                    NexusNodeType={libraryData?.result?.NexusNodeType}
                    GlobalNexusZone={itemsData?.result?.items}
                />
            }
        </>
    )
}

export default ManagementNexusNode;